module.exports = __webpack_public_path__ + "static/media/light-b-6.78b174bc.png";